/*
  Split The V — "Sunset" gedrag (homepage + productpagina-extra's)
  Gebruikt door sections/splitthev-home.liquid en sections/splitthev-product-extras.liquid

  Onderdelen:
  1. AJAX add-to-cart via event-delegatie op [data-stv-add] (Shopify AJAX Cart API)
  2. Gesimuleerde voorraadteller (fake urgency — zie kanttekening hieronder)
  3. Sticky bestelbalk bij scrollen (alleen homepage)
  4. Scrollend bierglas met "hit"-moment + kortingscode (alleen homepage, puur front-end)
  5. Gesimuleerde social-proof pop-ups (alleen homepage — zie kanttekening)
*/
(function () {
  'use strict';

  /* ── 1. AJAX add-to-cart (werkt op elke pagina) ─────────────────────
     Knoppen: <button data-stv-add data-quantity="2" data-variant-id="...">
     Zonder eigen data-variant-id valt de knop terug op de variant van de
     homepage-sectie (#stvs-root). De bevestigings-toast verschijnt via de
     globale /cart/add-hook in stv-toast.js. */
  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-stv-add]') : null;
    if (!btn || btn.disabled) return;

    var root = document.getElementById('stvs-root');
    var variantId = parseInt(btn.dataset.variantId || (root ? root.dataset.variantId : ''), 10);
    if (!variantId) return;

    var quantity = parseInt(btn.dataset.quantity, 10) || 1;
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Toevoegen…';

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity }],
        sections: 'cart-icon-bubble'
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        // "Direct bestellen": na toevoegen meteen door naar de winkelwagen
        if (btn.hasAttribute('data-stv-buy-now')) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (data.sections && data.sections['cart-icon-bubble'] && window.STVToast) {
          window.STVToast.updateCartBubble(data.sections['cart-icon-bubble']);
        }
        if (window.STVToast) window.STVToast.show();
        btn.disabled = false;
        btn.textContent = originalText;
      })
      .catch(function (err) {
        console.error('[STV Sunset] add-to-cart mislukt', err);
        btn.textContent = 'Er ging iets mis';
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        }, 2500);
      });
  });

  function init() {
    /* ── 2. Voorraadteller ───────────────────────────────────────────
       LET OP: dit aantal is GESIMULEERD en staat volledig los van de echte
       Shopify-voorraad. Het is bewust "fake urgency". Houd de range
       geloofwaardig: te lage of steeds wisselende aantallen ondermijnen
       het vertrouwen en schuren met regels rond oneerlijke
       handelspraktijken. Het aantal is stabiel per browsersessie zodat
       hero, panel en sticky balk hetzelfde getal tonen. */
    var stockEls = document.querySelectorAll('.stvs-stock-num');
    var root = document.getElementById('stvs-root');
    if (stockEls.length) {
      var stockMin = root ? parseInt(root.dataset.stockMin, 10) || 15 : 15;
      var stockMax = root ? parseInt(root.dataset.stockMax, 10) || 30 : 30;
      if (stockMax < stockMin) stockMax = stockMin;
      var stock;
      try { stock = parseInt(sessionStorage.getItem('stvs_stock'), 10); } catch (e) { /* private mode */ }
      if (!stock || stock < stockMin || stock > stockMax) {
        stock = stockMin + Math.floor(Math.random() * (stockMax - stockMin + 1));
        try { sessionStorage.setItem('stvs_stock', String(stock)); } catch (e) { /* noop */ }
      }
      stockEls.forEach(function (el) { el.textContent = stock; });
    }

    if (!root) return; // De rest is homepage-specifiek.

    /* ── 3 + 4. Sticky balk & bierglas (scroll-gedreven) ───────────── */
    var bar = document.getElementById('stvs-sticky-bar');
    var glass = root.dataset.glassEnabled === 'true' ? document.getElementById('stvs-glass') : null;
    var glassDismissed = false;
    try { glassDismissed = sessionStorage.getItem('stvs_glass_dismissed') === '1'; } catch (e) { /* noop */ }
    if (glass && glassDismissed) {
      glass.remove();
      glass = null;
    }

    var fillEl = glass ? glass.querySelector('[data-stv-glass-fill]') : null;
    var labelEl = glass ? glass.querySelector('[data-stv-glass-label]') : null;
    var glassBody = glass ? glass.querySelector('.stvs-glass__body') : null;
    var hitLatched = false;
    var confettiDone = false;

    if (glass) {
      var dismissBtn = glass.querySelector('[data-stv-glass-dismiss]');
      if (dismissBtn) {
        dismissBtn.addEventListener('click', function () {
          try { sessionStorage.setItem('stvs_glass_dismissed', '1'); } catch (e) { /* noop */ }
          glass.remove();
          glass = null;
          onScroll();
        });
      }
    }

    // Confetti-explosie op het "hit"-moment (26 snippers, eenmalig)
    function spawnConfetti() {
      if (confettiDone || !glassBody) return;
      confettiDone = true;
      var colors = ['#E5079E', '#5B1FD6', '#FFD23B', '#F7941D', '#FFFEFB', '#F5C518'];
      for (var i = 0; i < 26; i++) {
        var angle = (i / 26) * Math.PI * 2;
        var dist = 70 + Math.random() * 90;
        var piece = document.createElement('span');
        piece.className = 'stvs-confetti';
        piece.style.left = (67 + Math.cos(angle) * 10) + 'px';
        piece.style.top = (100 + Math.sin(angle) * 8) + 'px';
        piece.style.width = (6 + Math.random() * 6) + 'px';
        piece.style.height = (10 + Math.random() * 8) + 'px';
        piece.style.borderRadius = Math.random() > 0.5 ? '999px' : '2px';
        piece.style.background = colors[i % colors.length];
        piece.style.opacity = '0';
        piece.style.setProperty('--dx', (Math.cos(angle) * dist) + 'px');
        piece.style.setProperty('--dy', (Math.sin(angle) * dist - 40) + 'px');
        piece.style.animation = 'stvs-pop 1s ' + (Math.random() * 0.35).toFixed(2) + 's cubic-bezier(.22,.9,.3,1) forwards';
        glassBody.appendChild(piece);
      }
    }

    // Hit-niveau: de opening van het V-logo op het glas (50% vulling)
    var HIT = 0.50;
    // Max niveau: helemaal vol (100%). De schuimkraag zit binnen de vulling
    // (top van het bier) dus die wordt niet weggeknipt.
    var TOP = 1.0;
    var ticking = false;

    function update() {
      ticking = false;
      var de = document.documentElement;
      var max = de.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;

      var docked = false;
      var left = window.innerWidth - 169;
      var top = Math.round(window.innerHeight * 0.5 - 100);
      var dock = document.getElementById('stv-v-dock');
      if (dock) {
        var r = dock.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.92 && r.bottom > 60) {
          docked = true;
          left = Math.round(r.left + r.width / 2 - 85);
          top = Math.round(r.top + r.height / 2 - 166);
        }
      }

      var f;
      // Start helemaal vol; zakt geleidelijk terwijl je scrolt tot de opening
      // van de V (HIT), blijft daar even (het "hit"-moment), en loopt daarna leeg.
      if (p <= 0.50) f = TOP - (p / 0.50) * (TOP - HIT); // vol -> opening van de V
      else if (p <= 0.62) f = HIT; // hit-moment bij de V
      else f = Math.max(0, HIT - ((p - 0.62) / 0.30) * HIT); // daarna verder leeglopen
      f = Math.max(0, Math.min(TOP, f));

      var fill = docked ? HIT : f;
      var hit = hitLatched || docked || f <= HIT + 0.001;
      hitLatched = hit;

      if (hit && !docked) {
        // Gehit: glas + kortingspaneel gecentreerd in beeld
        left = Math.round(window.innerWidth / 2 - 85);
        top = Math.max(12, Math.round(window.innerHeight / 2 - 235));
      }

      if (bar) {
        bar.classList.toggle('is-visible', window.scrollY > 700 && !docked);
      }

      if (glass) {
        glass.style.left = left + 'px';
        glass.style.top = top + 'px';
        glass.classList.add('is-ready');
        glass.classList.toggle('is-docked', docked);
        glass.classList.toggle('is-hit', hit);
        glass.classList.toggle('show-panel', hit && !docked);
        glass.classList.toggle('is-interactive', hit || docked);
        glass.setAttribute('aria-hidden', hit || docked ? 'false' : 'true');
        // Niveau via 'top' zetten (top + bottom = ondubbelzinnige hoogte):
        // top = de lege ruimte boven het bier.
        if (fillEl) fillEl.style.top = (100 - fill * 100) + '%';
        if (labelEl) labelEl.textContent = fill >= TOP - 0.005 ? 'Scroll = drink 🍺' : Math.round(fill * 100) + '%';
        if (hit) spawnConfetti();
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    setTimeout(update, 300);

    /* ── 5. Social-proof pop-ups ─────────────────────────────────────
       LET OP: GESIMULEERDE social proof. Deze meldingen komen uit een
       vaste lijst en zijn NIET gekoppeld aan echte bestellingen. Houd
       frequentie en inhoud realistisch en niet spammerig; nep-social-
       proof die als echt gepresenteerd wordt is juridisch grijs gebied. */
    var proof = root.dataset.proofEnabled === 'true' ? document.getElementById('stvs-proof') : null;
    if (proof) {
      var messages = [
        '📦 Sem uit Utrecht bestelde 12 min geleden',
        '📦 Lisa uit Eindhoven bestelde net 2× Split The V',
        '🔥 Vandaag al 14× besteld',
        '📦 Daan uit Groningen bestelde 28 min geleden'
      ];
      var msgIndex = -1;
      var hideTimer = null;
      var showProof = function () {
        msgIndex = (msgIndex + 1) % messages.length;
        proof.textContent = messages[msgIndex];
        proof.classList.add('is-visible');
        clearTimeout(hideTimer);
        hideTimer = setTimeout(function () {
          proof.classList.remove('is-visible');
        }, 5200);
      };
      setTimeout(showProof, 3500);
      setInterval(showProof, 12000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
